import { render, staticRenderFns } from "./prod-detail.vue?vue&type=template&id=1d3084fe&scoped=true"
import script from "./prod-detail.vue?vue&type=script&lang=js"
export * from "./prod-detail.vue?vue&type=script&lang=js"
import style0 from "./prod-detail.vue?vue&type=style&index=0&id=1d3084fe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d3084fe",
  null
  
)

export default component.exports